import React, { useEffect, useState } from 'react';
import axios from 'axios'

import config from '../../settings/config.json'


const Poets = function() {
    const [writers, setWriters] = useState([]);

    useEffect(() => {
        const fetchWriters = async () => {
          try {
            const response = await axios.get(`/api/writers`);
            setWriters(response.data);
          } catch (error) {
            console.error('Error fetching:', error);
          }
        };
    
        fetchWriters();
        const interval = setInterval(fetchWriters, 3000);
        return () => clearInterval(interval);
    }, []);


    return (
        <div className='Poets'>
            <br /><br /><br /><br />
            
            <div className='center-content'>
                <span className='align-r'>
                    <span className='text-gradient bold'>Radio Face Baku</span> bu gün sizə xidət edir, <br />
                    öz varlığı ilə <span className='bold text-gradient'>Sizə</span>, dəstək<br />
                    olur, <span className='bold text-gradient'>Sizin</span> mürəkkəbinizi illər sonra dinlənilən səsə <span className='bold text-gradient'>çevirir</span>. Şairlərimizi <br />
                    tanıyın
                </span>
                <br />
                <div className='text_poets'>
                    <p>Radio Face 2012-ci ildə internet üzərindən sadə klassik musiqilərlə yayımını tək ünvanla başlayan internet radio idi.İldən-ilə inkişaf etdikcə Radio Face verilişlərə başladı,müxtəlif qonaqlar dəvət etdi.Marifləndirici məqsədlərlə işimizi davam etdirdik.Bu gün isə Radio Face Əbəbiyyatımıza,Şairlərimizə xüsusi yer ayıraraq formatıni dəyişib Ölkəmizin klassik və muasir ədəbiyyat davamçılarının qələmlərinə mürəkkəb qataraq onları dahada tanıdır və dəstəy olur. Azərbaycan ədəbiyyatında,klassik və ya muasir,yeniliyə aid nə varsa biz səsləndirməmizdə bunu etmişik.Göndərdiyiniz şeir və ya qəzəllərdə əbəbiyyat qaydalrnda kobud pozuntular qeydə alnınmasa göndərdiyiniz bizim tərəfimizdən səsləndiriləcəy...</p>
                </div>
            </div>
            <br /><br />
            <center><div className='divider'></div></center>
            <br />
            <center><h1><i class="bi bi-feather text-two"></i> ŞAİRLƏRİMİZ <i class="bi bi-feather text-one"></i></h1></center>

            {writers.length > 0 ? (
                <div>
                    {writers.map(writer => (
            <div key={writer.id}>
            <br /><br />
            <div className='center-content qw-pc'>
                <div>
                    <img className='ms-3 ggh'  src={`/api${writer.photo}`} width="150px" />
                    <br />
                    <h4 className='ms-3'>{writer.name}</h4>
                    <h6 className='ms-3 text-gradient'>{writer.surname}</h6>
                </div>
                <div className='text_poet'>
                    <p>{writer.bio}</p>
                </div>
            </div>
            <br /><br />
            <center><div className='red-divider qw-pc'></div></center>
                            
                <center className='qw-mobile p-3'>
                <div>
                    <img className='ms-3 ggh'  src={`/api${writer.photo}`} width="150px" />
                    <br />
                    <h4 className='ms-3'>{writer.name}</h4>
                    <h6 className='ms-3 text-gradient'>{writer.surname}</h6>
                </div>
                <div className='text_poet'>
                    <p>{writer.bio}</p>
                </div>
            </center>
            </div>
        ))}
    </div>
) : (
    <center className='mt-5'>
    <h2 className='text-gradient'>Oops...</h2>
    <br /><br /><br />
  </center>
)}


    
            <br /><br />
        </div>
    )
}

export default Poets;